import React from "react";
import { CategoryFilter } from "@/components/atomic/voc-filter/CategoryFilter";
import { PeriodFilter } from "@/components/atomic/voc-filter/PeriodFilter";
import { VocPeriodFilterType } from "@/models/vocPeriodFilter";

interface BasicFilterTabProps {
  filterContainerRef: React.RefObject<HTMLDivElement>;
  categories: string[];
  vocPeriodStart: Date | null;
  vocPeriodEnd: Date | null;
  vocPeriodType: VocPeriodFilterType;
  onUpdateState: (updates: {
    categories?: string[];
    vocPeriodStart?: Date | null;
    vocPeriodEnd?: Date | null;
    vocPeriodType?: VocPeriodFilterType;
  }) => void;
}

export const BasicFilterTab: React.FC<BasicFilterTabProps> = ({
  filterContainerRef,
  categories,
  vocPeriodStart,
  vocPeriodEnd,
  vocPeriodType,
  onUpdateState,
}) => {
  return (
    <div className="flex flex-col gap-6">
      {/* 対象期間（分析）セクション */}
      <PeriodFilter
        vocPeriodType={vocPeriodType as VocPeriodFilterType}
        vocPeriodStart={vocPeriodStart}
        vocPeriodEnd={vocPeriodEnd}
        onUpdateState={onUpdateState}
        filterContainerRef={filterContainerRef}
      />

      {/* カテゴリセクション */}
      <CategoryFilter
        categories={categories}
        onUpdateCategories={(newCategories) => onUpdateState({ categories: newCategories })}
      />
    </div>
  );
};
